import { Chip } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ScheduleIcon from "@mui/icons-material/Schedule";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

// Days left before a policy matures, coloured by how soon
export default function ExpiryChip({ days }) {
  if (days <= 0)
    return <Chip size="small" color="default" label="Matured" />;
  if (days <= 7)
    return (
      <Chip size="small" color="error" variant="outlined" icon={<ErrorOutlineIcon />} label={`${days} day${days === 1 ? "" : "s"}`} />
    );
  if (days <= 30)
    return (
      <Chip size="small" color="warning" variant="outlined" icon={<ScheduleIcon />} label={`${days} days`} />
    );
  return (
    <Chip size="small" color="success" variant="outlined" icon={<CheckCircleOutlineIcon />} label={`${days} days`} />
  );
}
